import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { DataService } from '../../../core/service/base/data.service';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { License } from '../../model/license';

export class LicenceLimitComparison {
  dwellingLimit: number;
  parkingLimit: number;
  otherObjectLimit: number;
  premisesSqmLimit: number;
  dwellingLevel: number;
  parkingLevel: number;
  otherObjectLevel: number;
  premisesSqmLevel: number;
  get levelsExceeded(): boolean {
    return (
      this.dwellingLevel > (this.dwellingLimit ?? this.dwellingLevel) ||
      this.parkingLevel > (this.parkingLimit ?? this.parkingLevel) ||
      this.otherObjectLevel > (this.otherObjectLimit ?? this.otherObjectLevel) ||
      this.premisesSqmLevel > (this.premisesSqmLimit ?? this.premisesSqmLevel)
    );
  }
}

@Injectable()
export class LicenseService extends DataService<License> {
  private licenses$?: Observable<License[]>;
  private limitsMaxedOut$?: Observable<boolean>;

  constructor(
    private _client: HttpClient,
    @Inject(APP_CONFIG) private _config: IAppConfig,
    messageService: MessageService,
    progressBar: ProgressBarService
  ) {
    super(_client, _config, messageService, License, progressBar, 'license');
  }

  getLicenses(): Observable<License[]> {
    if (!this.licenses$) {
      this.licenses$ = this._client.get<License[]>(this.endpoint).pipe(shareReplay(1));
    }
    return this.licenses$;
  }

  getLimitsComparison(): Observable<LicenceLimitComparison> {
    return this._client.get<LicenceLimitComparison>(`${this.endpoint}/limits`);
  }

  getLimitsMaxedOut(): Observable<boolean> {
    if (!this.limitsMaxedOut$) {
      this.limitsMaxedOut$ = this._client.get<boolean>(`${this.endpoint}/limitsMaxedOut`).pipe(shareReplay(1));
    }
    return this.limitsMaxedOut$;
  }

  refreshLimitsMaxedOut(): Observable<boolean> {
    this.clearLimitsCache();
    return this.getLimitsMaxedOut();
  }

  clearLimitsCache() {
    this.limitsMaxedOut$ = undefined;
  }
}
